export default "__VITE_ASSET__Dfav4PuX__"